import axios from "axios";

// export const baseUrl=`http://localhost:5080/`;
export const baseUrl=`/`;
// export const baseUrl=`https://mate.rashigames.com/`;

export const getGamesApi=async()=>{
    const response=await axios.get(`${baseUrl}api/v1/games`);
    return response;
}